import { Checkbox } from "@/components/ui/checkbox";
import { FAILURE_POINTS } from "@/lib/constants";
import { Section, SaveIndicator } from "./fields";

export const FailurePointsSection = ({ form, toggleFailurePoint, fp = () => ({}) }) => {
  const { state, error } = fp("failure_points");
  return (
    <Section
      title="Failure / leak points"
      number="04"
      hint="Tick all that apply (PTF1–PTF9)"
      fullWidth
    >
      {(state || error) && (
        <div className="md:col-span-3 -mt-2 flex items-center gap-3">
          <SaveIndicator state={state} fieldKey="failure_points" />
          {error && (
            <span data-testid="inline-error-failure_points" className="text-[11px] text-[#b30035] font-body">
              {error}
            </span>
          )}
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:col-span-3">
      {FAILURE_POINTS.map((point) => {
        const checked = form.failure_points.includes(point.code);
        return (
          <label
            key={point.code}
            data-testid={`failure-point-${point.code}`}
            className={`flex items-start gap-3 p-3 border cursor-pointer transition-colors ${
              checked ? "border-[#39678f] bg-[#e6f3ff]" : "border-[#33424f]/20 hover:border-[#33424f]/50"
            }`}
          >
            <Checkbox
              checked={checked}
              onCheckedChange={() => toggleFailurePoint(point.code)}
              className="mt-0.5 data-[state=checked]:bg-[#39678f] data-[state=checked]:border-[#39678f]"
            />
            <div>
              <div className="font-semibold text-sm tabular-nums">{point.code}</div>
              <div className="text-xs text-[#50493b]">{point.label}</div>
            </div>
          </label>
        );
      })}
    </div>
    </Section>
  );
};
